/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressCountryEnum } from './addressCountryEnum';
import { SubjectLicensePackBriefDetail } from './subjectLicensePackBriefDetail';

/**
 * Serializer for kindergarten (workplace) details within an organization.
 */
export interface OrganizationWorkplaceDetail { 
    readonly id: number;
    uuid?: string;
    /**
     * Uživatelský název pracoviště
     */
    name?: string;
    readonly officialName: string;
    /**
     * IZO
     */
    izo?: string;
    /**
     * Check if this is the current kindergarten the director is logged into.
     */
    readonly isCurrent: boolean;
    /**
     * Check if this kindergarten is primary for the current user.
     */
    readonly isPrimary: boolean;
    /**
     * Get count of active teachers (TeacherKindergarten relationships) in this kindergarten.
     */
    readonly teachersCount: number;
    /**
     * Get count of active children in this kindergarten.
     */
    readonly childrenCount: number;
    /**
     * Get count of archived children in this kindergarten.
     */
    readonly archivedChildrenCount: number;
    readonly licenses: Array<SubjectLicensePackBriefDetail>;
    /**
     * Get the nearest expiration date for any TRIAL feature, or None if no TRIAL features exist.
     */
    readonly trialExpiration: Date;
    code: string;
    readonly workplaceName: string;
    /**
     * Demo školka (pro testování a ukázky)
     */
    isDemo?: boolean;
    /**
     * Obec
     */
    addressCity?: string;
    /**
     * Ulice a číslo
     */
    addressStreet?: string;
    /**
     * PSČ
     */
    addressPostcode?: string;
    addressCountry?: AddressCountryEnum;
    /**
     * Okres
     */
    addressDistrict?: string;
}